export const heroData = {
  title: '探索 17c 的全新世界',
  subtitle: '一款备受关注的平台，为您带来高效便捷的全新体验',
  description: '17c 集成了强大的功能和直观的操作界面，帮助您轻松完成各项任务，提升工作效率，享受智能化服务带来的便利。',
  ctaPrimary: '立即体验',
  ctaSecondary: '了解更多',
};

export const features = [
  {
    id: 'feature-1',
    icon: 'ri-rocket-line',
    title: '高效快捷',
    description: '采用先进的技术架构，确保平台运行流畅，操作响应迅速，让您的工作效率倍增。',
  },
  {
    id: 'feature-2',
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: '多重安全防护机制，保障您的数据安全和隐私，让您使用无忧。',
  },
  {
    id: 'feature-3',
    icon: 'ri-smartphone-line',
    title: '多端同步',
    description: '支持多平台无缝切换，数据实时同步，随时随地畅享服务。',
  },
  {
    id: 'feature-4',
    icon: 'ri-user-heart-line',
    title: '用户至上',
    description: '以用户需求为导向，持续优化产品体验，提供贴心的客户服务支持。',
  },
  {
    id: 'feature-5',
    icon: 'ri-bar-chart-grouped-line',
    title: '数据分析',
    description: '强大的数据分析工具，帮助您洞察趋势，做出更明智的决策。',
  },
  {
    id: 'feature-6',
    icon: 'ri-settings-3-line',
    title: '灵活定制',
    description: '丰富的配置选项，满足不同用户的个性化需求，打造专属体验。',
  },
];

export const steps = [
  {
    step: '01',
    title: '注册账号',
    description: '使用手机号或邮箱快速注册，完成基础信息填写，即可开启您的 17c 之旅。',
  },
  {
    step: '02',
    title: '熟悉功能',
    description: '浏览平台各项功能模块，根据引导教程快速上手，了解核心操作流程。',
  },
  {
    step: '03',
    title: '开始使用',
    description: '根据您的需求选择相应功能，开始享受 17c 带来的高效便捷服务。',
  },
  {
    step: '04',
    title: '持续优化',
    description: '根据使用反馈不断调整设置，充分利用平台高级功能，最大化您的工作效率。',
  },
];

export const reviews = [
  {
    id: 'review-1',
    name: '张伟',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20person%20portrait%20photo%20with%20clean%20white%20background%2C%20friendly%20smile%2C%20warm%20lighting%2C%20professional%20headshot%20style%2C%20simple%20minimal%20composition&width=80&height=80&seq=avatar-01&orientation=squarish',
    role: '创业者',
    rating: 5,
    content: '17c 真的改变了我管理项目的方式。界面简洁直观，上手很快，功能也非常强大。用了三个月，工作效率提升了至少40%，强烈推荐给所有需要高效工具的伙伴！',
  },
  {
    id: 'review-2',
    name: '李娜',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20businesswoman%20portrait%20photo%20with%20clean%20white%20background%2C%20confident%20expression%2C%20soft%20natural%20lighting%2C%20modern%20headshot%2C%20simple%20composition&width=80&height=80&seq=avatar-02&orientation=squarish',
    role: '自由职业者',
    rating: 5,
    content: '作为一个自由职业者，17c 帮我很好地组织了日常工作和客户管理。数据分析功能特别赞，能清晰看到自己的工作趋势。客服响应也很快，遇到问题基本都能及时解决。',
  },
  {
    id: 'review-3',
    name: '王强',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20portrait%20photo%20with%20clean%20white%20background%2C%20friendly%20smile%2C%20natural%20lighting%2C%20corporate%20headshot%20style%2C%20minimal%20composition&width=80&height=80&seq=avatar-03&orientation=squarish',
    role: '企业管理者',
    rating: 4,
    content: '我们团队从去年开始使用 17c，整体体验非常不错。协同功能让团队沟通更高效，数据报表也帮助我们做出了更精准的决策。唯一希望的是能有更多定制化选项。',
  },
  {
    id: 'review-4',
    name: '赵敏',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%20photo%20with%20clean%20white%20background%2C%20warm%20genuine%20smile%2C%20soft%20studio%20lighting%2C%20corporate%20headshot%2C%20elegant%20minimal%20style&width=80&height=80&seq=avatar-04&orientation=squarish',
    role: '设计师',
    rating: 5,
    content: '作为一名设计师，我对工具的 UI 比较挑剔。17c 的界面设计真的很棒，简洁大气，交互流畅。功能方面也很全面，项目管理、文件共享都很方便，大大减少了沟通成本。',
  },
  {
    id: 'review-5',
    name: '陈浩',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20portrait%20photo%20with%20clean%20white%20background%2C%20professional%20attire%2C%20natural%20expression%2C%20studio%20lighting%2C%20headshot%20style%2C%20simple%20composition&width=80&height=80&seq=avatar-05&orientation=squarish',
    role: '技术开发者',
    rating: 5,
    content: '17c 的 API 接口设计得很合理，接入我们的系统非常顺畅。文档详细，示例丰富，即使是新手也能快速上手。技术团队的支持也很到位，是值得信赖的平台。',
  },
];